import { Link } from 'gatsby';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import './breadcrumb.scss';

interface BreadcrumbInterface {
    content: any;
    specialEvent?: boolean;
}

const Breadcrumb = (props: BreadcrumbInterface) => {
    const { content } = props;
    const { isBrowser } = useBrowserMode();

    const breadcrumbs = (crumbs: string) => {
        const segments = crumbs
            .split('/')
            .map((value) => value.trim())
            .filter(Boolean);
        return segments.map((value, index) => {
            const pathSegments = segments
                .slice(1, index + 1)
                .map((segment) =>
                    segment.toLowerCase().includes('certificados y consultas')
                        ? 'certificados'
                        : segment.replace(/\s+/g, '-').toLowerCase()
                );

            const path = '/' + pathSegments.join('/');

            return (
                <li
                    key={index}
                    itemProp="url"
                    className={`crumb url-${index}${
                        props.specialEvent ? ' --special-event' : ''
                    }`}
                >
                    <Link
                        title={value}
                        to={path.toLocaleLowerCase()}
                        rel="noopener noreferrer"
                    >
                        <span itemProp="title">{value}</span>
                    </Link>
                </li>
            );
        });
    };

    return (
        <nav itemType="https://schema.org/Breadcrumb" className="miga-de-pan">
            <ul
                className={`a-breadcrumb${
                    props.specialEvent ? ' a-breadcrumb--special-event' : ''
                }`}
            >
                {isBrowser && breadcrumbs(content)}
            </ul>
        </nav>
    );
};

export default Breadcrumb;
